module.exports = __webpack_public_path__ + "static/media/Artboard4.7b045970.png";